import React from 'react';
import HomeSection from '../sections/HomeSection';
import ProjectsSection from '../sections/ProjectsSection';
import SkillsSection from '../sections/SkillsSection';
import AboutSection from '../sections/AboutSection';
import ContactSection from '../sections/ContactSection';
import { Box } from '@mui/material';

function Main() {
  return (
    <main>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column', 
          width: '100%',
          overflow:'hidden'
        }}
      >
        <HomeSection />
        <AboutSection />
        <ProjectsSection />
        <SkillsSection />
        <ContactSection />
      </Box>
    </main>
  );
}

export default Main;
